const dark = {
  title: 'dark',

  colors: {
    primary: '#6e61c6',
    secondary: '#ffffff',
    tertiary: '#f5f5f5',

    white: '#ffffff',
    black: '',
    gray: '#9aa4bf',
    darkGray: '#293249',

    danger: '',
    success: '#03bb85',
    info: '#5753e4',
    warning: '#ff6961',

    textColor: '#ffffff',
    secundaryTextColor: '#9aa4bf',

    bgContent: '#161b28',
    bgBox: '#1d2333',
    bgAnimation: '#1d2333',
    shadowBox: '0 0 40px 0 rgba(0,0,0,.06);',

    bgBoxMenu: '#293249',
    shadowMenu: '3px 5px 20px 0 rgba(0,0,0,.12);',

    shadowAlternative: '3px 5px 40px 0 rgba(0,0,0,.1)',

    timelineColor: '#6e61c6',

    textAreaWizColor: '#141821',
  }
};

export default dark;
